export const TYPE = {
  PALLETS: "Pallet",
  BOXES: "Box",
};
